import { Component } from "@angular/core";

@Component({
  selector: "app-premium-acceptance",
  templateUrl: "./premium-acceptance.component.html",
  styleUrls: ["./premium-acceptance.component.scss"],
  standalone: false
})
export class PremiumAcceptanceComponent {}
